/**
 * /[^\u4e00-\u9fa5a-zA-Z\d,\.，。]+/ \d.
 *
 *  /[^\w\.\/]/  允许输入英文字母，小数点，数字，禁止输入中文字符以及其他特殊字符！
 *     let regMoney = /^(\-|\+)?\d+(\.\d+)?$/  只能输入一个小数点
 *     let regMoney = /^[\d.]+$/   数字和小数点线组合
 *     let regMoney =  /^\d+$|^\d+[.]?\d+$/ 只能输入一个小数点
 */
const regId = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
const email = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/ // 邮箱
const tel = /^((\d{11})|(\d{7,8})|(\d{4}|\d{3})-(\d{7,8}))$/ // 手机号码
const fax = /^(\d{3,4}-)?\d{7,8}$/ // 传真
const name = /^[\u4E00-\u9FA5\uf900-\ufa2d·s]{2,10}$/ // 姓名
const codes = /^[0-9a-zA-Z]*$/ // 编号
const regMoney = /^(\-|\+)?\d+(\d+)?$/
const ipcode = /^\d{1,8}(\.\d{1,2})?$/ // 数字小数点
const numTrue = /^[1-9]\d{0,4}$/// 输入最多5
const numberEn = /^\d+\w+$/
const URL = /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[\-;:&=\+\$,\w]+@)?[A-Za-z0-9\.\-]+|(?:www\.|[\-;:&=\+\$,\w]+@)[A-Za-z0-9\.\-]+)((?:\/[\+~%\/\.\w\-_]*)?\??(?:[\-\+=&;%@\.\w_]*)#?(?:[\.\!\/\\\w]*))?)/

const reg = new RegExp(/\s/g)// 清空字符串中所有空格

const code = /^[0-9a-zA-Z_]{1,}$/// 英文数字下划线

// 参数编号：允许大小写英文、数字及可见符号（排除空格）
const paramCode = /^[!-~]{1,}$/

const FormValidate = (function () {
  // eslint-disable-next-line
  function FormValidate() { }
  // From表单验证规则  可用于公用的校验部分
  FormValidate.Form = function (str) {
    return {
      // 姓名的验证规则
      Name: function (rule, value, callback) {
        if (!value) {
          return callback(new Error($t('integration.name_cannot_be_empty')))
        }
        if (!name.test(value)) {
          callback(new Error($t('integration.please_enter_the_correct_name_e')))
        } else {
          callback()
        }
      },
      // 邮箱的正则
      Email: function (rule, value, callback) {
        if (!value) {
          return callback(new Error($t('integration.mailbox_cannot_be_empty')))
        }
        if (!email.test(value)) {
          callback(new Error($t('integration.please_enter_the_correct_email_e')))
        } else {
          callback()
        }
      },
      // 身份证的验证规则
      ID: function (rule, value, callback) {
        if (!value) {
          return callback(new Error($t('integration.id_card_cannot_be_empty')))
        }
        if (!regId.test(value)) {
          callback(new Error($t('integration.please_enter_the_correct_second-generation_id_card_number')))
        } else {
          callback()
        }
      },
      // 电话号码的验证
      Tel: (rule, value, callback) => {
        if (!value) {
          return callback(new Error($t('integration.phone_cannot_be_empty')))
        }
        if (!tel.test(value)) {
          callback(new Error(window.vm.$t('validate.customer_phone_format')))
        } else {
          callback()
        }
      },
      // 编号的验证  英文字母和数字
      Code: (rule, value, callback) => {
        if (!value) {
          return callback(new Error(window.vm.$t('messageTitle.ContentNotEmpty')))
        }
        if (!codes.test(value)) {
          callback(new Error($t('integration.only_english_letters_and_numbers_can_be_included')))
        } else if (reg.test(value)) {
          callback(new Error($t('integration.cannot_contain_spaces')))
        } else {
          callback()
        }
      },
      // 编号的验证  英文字母和数字
      Codes: (rule, value, callback) => {
        // if (!value) {
        //   return callback(new Error(window.vm.$t('messageTitle.ContentNotEmpty')))
        // }
        if (value && !code.test(value)) {
          callback(new Error($t('integration.it_can_only_contain_english_letters_c__numbers_and_underscores')))
        } else {
          callback()
        }
      },
      // 参数编号的验证：大小写英文、数字及可见符号（排除空格）
      ParamCode: (rule, value, callback) => {
        if (value && !paramCode.test(value)) {
          callback(new Error($t('integration.param_code_can_only_contain_letters_numbers_and_symbols')))
        } else {
          callback()
        }
      },
      //
      ipCode: (rule, value, callback) => {
        if (!value) {
          return callback(new Error($t('integration.content_cannot_be_empty')))
        }
        if (!ipcode.test(value)) {
          callback(new Error($t('integration.please_fill_in_the_address_correctly')))
        } else if (reg.test(value)) {
          callback(new Error($t('integration.cannot_contain_spaces')))
        } else {
          callback()
        }
      },

      numTrue: (rule, value, callback) => {
        if (!value) {
          return callback(new Error($t('integration.content_cannot_be_empty')))
        }
        if (!numTrue.test(value)) {
          callback(new Error($t('integration.the_input_content_is_a_positive_integer_and_the_maximum_length_is_5')))
        } else if (reg.test(value)) {
          callback(new Error($t('integration.cannot_contain_spaces')))
        } else {
          callback()
        }
      },

      // 只能输入一个小数  正负数字范围区间
      figure: (rule, value, callback) => {
        if (!value) {
          return callback(new Error($t('integration.content_cannot_be_empty')))
        }
        if (value && !regMoney.test(value)) {
          callback(new Error($t('integration.please_enter_an_integer')))
        } else if (value > 255) {
          callback(new Error($t('integration.cannot_exceed_255')))
        } else if (value < -256) {
          callback(new Error('不能小于-256'))
        } else {
          return callback()
        }
      },
      // 只能输入一个小数  正负数字范围区间
      figures: (rule, value, callback) => {
        if (!value) {
          return callback(new Error($t('integration.content_cannot_be_empty')))
        }
        if (value && !regMoney.test(value)) {
          callback(new Error($t('integration.please_enter_an_integer')))
        } else if (value > 327) {
          callback(new Error($t('integration.cannot_be_greater_than_327')))
        } else if (value < -327) {
          callback(new Error('不能小于-327'))
        } else {
          return callback()
        }
      },
      figure1: (rule, value, callback) => {
        if (!value) {
          return callback(new Error(window.vm.$t('messageTitle.ContentNotEmpty')))
        }
        if (value && !regMoney.test(value)) {
          callback(new Error($t('integration.please_enter_an_integer')))
        } else if (value > 30) {
          callback(new Error($t('integration.cannot_be_greater_than_30')))
        } else if (value < 0) {
          callback(new Error($t('integration.cannot_be_less_than_0')))
        } else {
          return callback()
        }
      },
      figure3: (rule, value, callback) => {
        const arr = value.split(' ')
        arr.forEach(el => {
          if (el && !regMoney.test(el)) {
            return callback(new Error($t('integration.please_enter_an_integer')))
          } else if (el > 26) {
            return callback(new Error($t('integration.cannot_be_greater_than_26')))
          } else if (el < 11) {
            return callback(new Error($t('integration.cannot_be_less_than_11')))
          }
        })
      },
      figure2: (rule, value, callback) => {
        if (!value) {
          return callback(new Error(window.vm.$t('messageTitle.ContentNotEmpty')))
        }
        if (value && !regMoney.test(value)) {
          callback(new Error($t('integration.please_enter_an_integer')))
        } else if (value > 60) {
          callback(new Error($t('integration.cannot_be_greater_than_60')))
        } else if (value < 0) {
          callback(new Error($t('integration.cannot_be_less_than_0')))
        } else {
          return callback()
        }
      },
      figure4: (rule, value, callback) => {
        if (!value) {
          return callback(new Error($t('integration.content_cannot_be_empty')))
        }
        if (value && !regMoney.test(value)) {
          callback(new Error($t('integration.please_enter_an_integer')))
        } else if (value > 20) {
          callback(new Error($t('integration.cannot_be_greater_than_20')))
        } else if (value < -20) {
          callback(new Error('不能小于-20'))
        } else {
          return callback()
        }
      },
      // 只能输入一个小数  正负数字范围区间
      figuresN: (rule, value, callback) => {
        if (!value) {
          return callback(new Error($t('integration.content_cannot_be_empty')))
        }
        if (value && !regMoney.test(value)) {
          callback(new Error($t('integration.please_enter_an_integer')))
        } else if (value > 100) {
          callback(new Error($t('integration.cannot_be_greater_than_100')))
        } else if (value < 0) {
          callback(new Error($t('integration.cannot_be_less_than_0')))
        } else {
          return callback()
        }
      },
      figuresTime: (rule, value, callback) => {
        if (!value) {
          return callback(new Error($t('integration.content_cannot_be_empty')))
        }
        if (value && !regMoney.test(value)) {
          callback(new Error($t('integration.please_enter_an_integer')))
        } else if (value > 60) {
          callback(new Error('输入范围在1~60'))
        } else if (value < 1) {
          callback(new Error('输入范围在1~60'))
        } else {
          return callback()
        }
      },
      // 输入数字或字母
      numberEn: (rule, value, callback) => {
        if (!numberEn.test(value)) {
          callback(new Error($t('integration.only_numbers_or_letters_can_be_entered_e')))
        }
      },
      URL: (rule, value, callback) => {
        if (!URL.test(value)) {
          callback(new Error($t('integration.please_enter_the_correct_url_e')))
        } else {
          return callback()
        }
      },
      rangeFn: (rule, value, callback) => {
        if (value.length > 100) {
          callback(new Error($t('integration.length_cannot_exceed_100')))
        } else {
          return callback()
        }
      }
    }
  }

  // FromOne表单验证规则  用于FromOne个性化的校验
  FormValidate.FormOne = function () {
    return {
      // 姓名的验证规则
      Name: function (rule, value, callback) {
        if (!value) {
          return callback(new Error($t('integration.name_cannot_be_empty')))
        }
        if (!name.test(value)) {
          callback(new Error($t('integration.please_enter_the_correct_name_e')))
        } else {
          callback()
        }
      }
    }
  }
  // 迭代二期的校验
  FormValidate.maxMinFn = function (str) {
    const reg = /(^-?(?:\d+|\d{1,3}(?:,\d{3})+)(?:\.\d{1,2})?$)/// 两位小数且是数字
    const reg2 = /^\d+$|^\d+[.]?\d+$/// 只能输入数字
    const reg3 = /[^\d]/g// 禁止小数
    const reg4 = /^[0-9a-zA-Z]*$/// 数字和英文
    const reg5 = /^[\d\s]+$/ // 数字+空格
    return {
      // 迭代二期传感器参数的校验
      maxMin: function (rule, value, callback) {
        if (str === 'max_temp' || str === 'min_temp' || str === 'report_change_temp' || str === 'report_change_hum' || str === 'alarmInterval') { // 最大值为327.67   最小值为-327.67
          if (Number(value) > 327.67 || Number(value) < -327.67) {
            return callback(new Error('范围在-327.67~327.67'))
          } else if (!reg.test(value)) {
            return callback(new Error($t('integration.two_decimal_places_and_numbers')))
          } else {
            callback()
          }
        } else if (str === 'interval' || str === 'ex_interval' || str === 'alarm_duration') {
          if (Number(value) > 65535 || Number(value) < 1) {
            return callback(new Error('范围在1~65535'))
          } else if (!reg2.test(value)) {
            return callback(new Error($t('integration.only_numbers_can_be_entered')))
          } else {
            callback()
          }
        } else if (str === 'max_report_interval_temp' || str === 'min_report_interval_temp' || str === 'interval_temp' || str === 'max_report_interval_hum' || str === 'min_report_interval_hum') {
          if (Number(value) > 65535 || Number(value) < 1) {
            return callback(new Error('范围在1~65535'))
          } else if (reg3.test(value)) {
            return callback(new Error($t('integration.no_decimal_point')))
          } else {
            callback()
          }
        } else if (str === 'max_humidity' || str === 'min_humidity') { // 最大值为327.67   最小值为-327.67
          if (Number(value) > 100 || Number(value) < 0) {
            return callback(new Error('范围在0.00~100.00'))
          } else if (!reg.test(value)) {
            return callback(new Error($t('integration.two_decimal_places_and_numbers')))
          } else {
            callback()
          }
        }
      },
      netRule: function (rule, value, callback) {
        if (str === 'extPanId' || str === 'appEUI') {
          if (value.length !== 16) {
            return callback(new Error($t('integration.the_length_can_only_be_16_bits')))
          } else if (!reg4.test(value)) {
            return callback(new Error($t('integration.the_content_is_only_in_figures_and_english')))
          } else {
            return callback()
          }
        } else if (str === 'channelMask') {
          const vail = String(value).split(' ').filter(function (s) {
            return s && s.trim()
          })
          const rule = vail.every(element => {
            return element >= 0 && element <= 31
          })
          if (!rule) {
            return callback(new Error('仅限0~31数字，多个以空格隔开'))
          } else {
            return callback()
          }
        } else if (str === 'channelPage') {
          if (Number(value) < 0 || Number(value) > 255) {
            return callback(new Error('范围在0~255'))
          } else if (!reg2.test(value)) {
            return callback(new Error($t('integration.only_numbers_can_be_entered')))
          } else {
            return callback()
          }
        } else if (str === 'access_interval') {
          if (Number(value) < 300 || Number(value) > 86400) {
            return callback(new Error('范围在300~86400'))
          } else if (!reg2.test(value)) {
            return callback(new Error($t('integration.only_numbers_can_be_entered')))
          } else {
            return callback()
          }
        } else if (str === 'devEUI') {
          if (value.length !== 10) {
            return callback(new Error($t('integration.the_length_can_only_be_10_digits')))
          } else if (!reg4.test(value)) {
            return callback(new Error($t('integration.the_content_is_only_in_figures_and_english')))
          } else {
            return callback()
          }
        } else if (str === 'appKey') {
          if (value.length !== 32) {
            return callback(new Error($t('integration.the_length_can_only_be_32_bits')))
          } else if (!reg4.test(value)) {
            return callback(new Error($t('integration.the_content_is_only_in_figures_and_english')))
          } else {
            return callback()
          }
        } else if (str === 'interval') {
          if (Number(value) < 1 || Number(value) > 86400) {
            return callback(new Error('范围在1~86400'))
          } else if (!reg2.test(value)) {
            return callback(new Error($t('integration.only_numbers_can_be_entered')))
          } else {
            return callback()
          }
        } else if (str === 'power') {
          if (Number(value) < 0 || Number(value) > 20) {
            return callback(new Error('范围在0~20'))
          } else if (!reg2.test(value)) {
            return callback(new Error($t('integration.only_numbers_can_be_entered')))
          } else {
            return callback()
          }
        } else {
          return callback()
        }
      }
    }
  }
  //  迭代三期的校验
  FormValidate.numMaxFn = function (str) {
    console.log(str)
    const reg2 = /^\d+$|^\d+[.]?\d+$/// 只能输入数字
    return {
      num50: function (rule, value, callback) {
        if (str === 'number') {
          if (!reg2.test(value) && value !== null) {
            return callback(new Error($t('integration.please_enter_a_number')))
          } else if ((value < 1 || value > 65535) && value !== null) {
            return callback(new Error('范围在1~65535'))
          } else {
            return callback()
          }
        } else if (str === 'numbersn') {
          if (!reg2.test(value) && value !== null) {
            return callback(new Error($t('integration.please_enter_a_number')))
          } else {
            return callback()
          }
        }
      }
    }
  }

  return FormValidate
}())
exports.FormValidate = FormValidate
